(function () {
  "use strict";
  var CAT_URL = "/pages/screen-printing-pricing-calculator";

  function params() {
    var out = {};
    function eat(str) {
      String(str || "").replace(/^[#?]/, "").split("&").forEach(function (p) {
        var i = p.indexOf("=");
        if (i < 0) return;
        var k = decodeURIComponent(p.slice(0, i)).toLowerCase();
        out[k] = decodeURIComponent(p.slice(i + 1).split("+").join(" "));
      });
    }
    eat(location.search);
    eat(location.hash);
    return out;
  }

  function whole(v, lo, hi) {
    var n = parseInt(v, 10);
    if (isNaN(n)) return null;
    return Math.max(lo, Math.min(hi, n));
  }

  function applySpecs() {
    var S = window.S;
    if (!S) return false;
    var p = params(), hit = false, v;
    if (p.front != null) {
      v = whole(p.front, 0, 8);
      if (v !== null) { S.front = v; hit = true; }
    }
    if (p.back != null) {
      v = whole(p.back, 0, 8);
      if (v !== null) { S.back = v ? Math.max(1, v) : 0; hit = true; }
    }
    if (!S.front && !S.back) S.front = 1;
    if (p.qty != null) {
      v = whole(p.qty, 12, 5000);
      if (v !== null) { S.qty = v; hit = true; }
    }
    return hit;
  }

  function specHash() {
    var S = window.S;
    if (!S) return "";
    var bits = ["front=" + (S.front || 0)];
    if (S.back) bits.push("back=" + S.back);
    bits.push("qty=" + (S.qty || 12));
    return "#" + bits.join("&");
  }

  function catalogLink() {
    return location.origin + CAT_URL + specHash();
  }

  function wrapProductURL() {
    if (typeof window.styleHref !== "function") return;
    window.productURL = function (style) {
      if (!style) return catalogLink();
      return location.origin + window.styleHref(style) + specHash();
    };
  }

  function addBarCopy() {
    var say = document.getElementById("barSay");
    if (!say || document.getElementById("barCopy")) return;
    var b = document.createElement("button");
    b.type = "button";
    b.id = "barCopy";
    b.className = "barCopy";
    b.textContent = "Copy link";
    b.title = "Copy a link to the catalog with these specs";
    b.addEventListener("click", function () {
      if (typeof window.copyText === "function") {
        window.copyText(catalogLink(), b, "Link copied");
      }
    });
    say.parentNode.insertBefore(b, say.nextSibling);
  }

  function ready() {
    return window.S && typeof window.render === "function" &&
      window.STYLES && window.STYLES.length;
  }

  function start() {
    if (!ready()) return false;
    wrapProductURL();
    addBarCopy();
    if (applySpecs()) {
      window.render();
      if (typeof window.syncDock === "function") window.syncDock();
    }
    return true;
  }

  if (!start()) {
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      if (start() || tries > 100) clearInterval(iv);
    }, 50);
  }
})();